<script lang="ts" setup>
import ogImage from '@images/og-image.png'

const { $api } = useNuxtApp()
const config = useRuntimeConfig()
const { locale } = useI18n()

// Helper for type-safe locale access
const lang = computed(() => locale.value as 'en' | 'id')

const url = computed(() => {
    return `${config.public.jobSeekerUrl}/terms-conditions`
})

// Fetching data from API
const { data } = await $api.landingPage.getTermsAndConditions()

// Computed titles for reactivity and fallback
const termsTitle = computed(() => {
    const titles = data.value?.data?.title || { en: 'Terms & Conditions', id: 'Syarat & Ketentuan' }
    return titles[lang.value] || titles.en
})

// Computed content logic
const termsContent = computed(() => {
    return data.value?.data?.content?.description[lang.value] || ''
})

/** Head configurations */
useSeoMeta({
    title: () => termsTitle.value,
    description: () => lang.value === 'id'
        ? 'Tinjau Syarat & Ketentuan kami untuk memahami aturan dan pedoman penggunaan layanan kami.'
        : 'Review our Terms & Conditions to understand the rules and guidelines for using our services.',
    ogType: 'website',
    ogUrl: () => url.value,
    ogTitle: () => termsTitle.value, // Fixed: was "Privacy Policy"
    ogDescription: () => lang.value === 'id'
        ? 'Tinjau Syarat & Ketentuan kami untuk memahami aturan dan pedoman penggunaan layanan kami.'
        : 'Review our Terms & Conditions to understand the rules and guidelines for using our services.',
    ogImage: () => ogImage,
    twitterCard: 'summary_large_image',
    twitterTitle: () => termsTitle.value,
})

useHead({
    link: [
        {
            rel: 'canonical',
            href: url.value,
    }
    ]
})
</script>

<template>
  <VContainer>
    <h1 class="text-h4 mb-6">
      {{ termsTitle }}
    </h1>

    <VCard
      v-if="termsContent"
      flat
      border
    >
      <VCardText class="pa-6">
        <div
          class="terms-condition-content"
          v-html="termsContent"
        />
      </VCardText>
    </VCard>

    <div
      v-else
      class="text-center pa-10"
    >
      <VProgressCircular
        indeterminate
        color="primary"
      />
    </div>
  </VContainer>
</template>

<style lang="scss" scoped>
:deep(.terms-condition) {
    ul,
    ol {
        padding-left: 20px;
    }
}
</style>
